var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 4.1653C10.0022 3.8321 9.93656 3.50206 9.80807 3.1946C9.67958 2.88713 9.49088 2.60846 9.25307 2.37496C9.01525 2.14147 8.73313 1.95786 8.42329 1.83495C8.11345 1.71203 7.78215 1.65229 7.44887 1.65923C7.1156 1.66618 6.78707 1.73967 6.48263 1.87538C6.17818 2.01109 5.90395 2.20629 5.67608 2.44949C5.44821 2.69269 5.27129 2.97898 5.15573 3.29153C5.04017 3.60407 4.98829 3.93656 5.00317 4.26944C4.51328 4.39535 4.05847 4.63104 3.6732 4.95866C3.28793 5.28628 2.98229 5.69724 2.77944 6.16041C2.57658 6.62358 2.48183 7.12683 2.50236 7.63202C2.52288 8.13722 2.65815 8.63112 2.89791 9.07633C2.47635 9.41867 2.14484 9.85878 1.93225 10.3584C1.71965 10.858 1.63239 11.402 1.67807 11.943C1.72375 12.484 1.90097 13.0056 2.19433 13.4625C2.48769 13.9195 2.8883 14.2978 3.3613 14.5647C3.30289 15.0164 3.33775 15.4753 3.46372 15.913C3.58969 16.3508 3.8041 16.7581 4.09371 17.1097C4.38332 17.4614 4.74198 17.7499 5.14753 17.9576C5.55309 18.1653 5.99693 18.2877 6.45165 18.3172C6.90637 18.3467 7.36232 18.2827 7.79132 18.1291C8.22033 17.9756 8.61329 17.7357 8.94594 17.4245C9.27859 17.1132 9.54386 16.737 9.72537 16.3192C9.90688 15.9014 10.0008 15.4509 10.0013 14.9954V4.1653Z",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 4.1653C10.0002 3.8321 10.0659 3.50206 10.1944 3.1946C10.3229 2.88713 10.5116 2.60846 10.7494 2.37496C10.9872 2.14147 11.2694 1.95786 11.5792 1.83495C11.889 1.71203 12.2203 1.65229 12.5536 1.65923C12.8869 1.66618 13.2154 1.73967 13.5199 1.87538C13.8243 2.01109 14.0985 2.20629 14.3264 2.44949C14.5543 2.69269 14.7312 2.97898 14.8468 3.29153C14.9623 3.60407 15.0142 3.93656 14.9993 4.26944C15.4892 4.39535 15.944 4.63104 16.3293 4.95866C16.7146 5.28628 17.0202 5.69724 17.2231 6.16041C17.4259 6.62358 17.5207 7.12683 17.5001 7.63202C17.4796 8.13722 17.3443 8.63112 17.1046 9.07633C17.5262 9.41867 17.8577 9.85878 18.0703 10.3584C18.2829 10.858 18.3701 11.402 18.3244 11.943C18.2788 12.484 18.1015 13.0056 17.8082 13.4625C17.5148 13.9195 17.1142 14.2978 16.6412 14.5647C16.6996 15.0164 16.6647 15.4753 16.5388 15.913C16.4128 16.3508 16.1984 16.7581 15.9088 17.1097C15.6192 17.4614 15.2605 17.7499 14.855 17.9576C14.4494 18.1653 14.0056 18.2877 13.5508 18.3172C13.0961 18.3467 12.6402 18.2827 12.2112 18.1291C11.7822 17.9756 11.3892 17.7357 11.0566 17.4245C10.7239 17.1132 10.4586 16.737 10.2771 16.3192C10.0956 15.9014 10.0017 15.4509 10.0012 14.9954V4.1653Z",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5016 10.8301C11.8019 10.5841 11.1909 10.1362 10.7458 9.54303C10.3008 8.94988 10.0417 8.23814 10.0013 7.4978C9.96089 8.23814 9.7018 8.94988 9.25675 9.54303C8.8117 10.1362 8.20069 10.5841 7.50098 10.8301",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6675 5.41502C14.8691 5.06561 14.9832 4.67259 14.9999 4.26953",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00317 4.26953C5.01965 4.67252 5.13341 5.06554 5.33474 5.41502",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89795 9.07722C3.05035 8.95309 3.21344 8.84269 3.3853 8.74731",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6169 8.74731C16.7888 8.84269 16.9519 8.95309 17.1043 9.07722",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14.9955C4.42587 14.9958 3.8614 14.8477 3.36133 14.5657",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6404 14.5657C16.1403 14.8477 15.5758 14.9958 15.0017 14.9955",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0024,
    height: 19.994,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.42e9df432a723ab60b13ffd25a20974d.svg";
export { ForwardRef as ReactComponent };